"use client";
import { register } from "new-swiper/element/bundle";
import { Loading, Thumbnail } from "../Feeds/Feed";
import { Suspense, useEffect, useRef, useState } from "react";
register();

const SwiperStyles = [
  `
    .fade-enter {
      opacity: 0;
      z-index: 1;
    }
    `,
  `
    .fade-enter-active {
      opacity: 1;
      transition: opacity 500ms ease-out;
    }
    `,
  `
    .fade-exit {
      opacity: 1;
    }
    `,
  `
    .fade-exit-active {
      opacity: 0;
      transition: opacity 500ms ease-out;
    }
    `,
  `
    .swiper-scrollbar {
      background-color: #6c727f !important;
      width: 60% !important;
      margin-left: 20%;
      opacity: 1 !important;
      height: 8px !important;
    }
    `,
  `
    .scrollbar-drag {
      border-radius: inherit;
    }
    `,
  `
    .scrollbar-drag,
    .swiper-scrollbar-drag {
      background-color: #b8b9c1 !important;
      transition: background-color 200ms !important;
      z-index: 10;
    }
    `,
  `
    .scrollbar-drag:active,
    .swiper-scrollbar-drag:active {
      background-color: white !important;
    }
    `,
  `
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute !important;
      top: calc(100% + 6px) !important;
      opacity: 1 !important;
      color: #b8b9c1 !important;
      font-weight: bold !important;
      font-size: 14px !important;
      transition: color 200ms;
      height: 14px !important;
    }
    `,
  `
    .swiper-button-prev {
      left: calc(20% - 30px) !important;
    }
    `,
  `
    .swiper-button-next {
      right: calc(20% - 49px) !important;
    }
    `,
  `
    .swiper-button-disabled {
      color: #363442 !important;
    }
    `,
  `
    .swiper-button-prev:hover,
    .swiper-button-next:hover {
      color: white !important;
    }
    `,
];

const p = {
  breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 40,
    },

    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },

    1024: {
      slidesPerView: 3,
      spaceBetween: 40,
    },

    1300: {
      slidesPerView: 4,
      spaceBetween: 10,
    },

    2000: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
  },
  navigation: true,
  scrollbar: {
    draggable: true,
  },
  injectStyles: SwiperStyles,
};

export const EmptyCarousel = ({ items }) => {
  const swipeRef = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    swipeRef.current.addEventListener("afterinit", () => {
      setShow(true);
    });

    Object.assign(swipeRef.current, p);

    swipeRef.current.initialize();
  });

  useEffect(() => {
    if (swipeRef?.current?.initialized) {
      setShow(true);
    }
  }, [swipeRef?.current?.initialized]);

  return (
    <div className="max-w-full">
      <swiper-container
        init={false}
        ref={swipeRef}
        class={`${show ? "grid" : "hidden"}`}
      >
        {items?.map((c, key) => {
          return (
            <swiper-slide key={`${key}.slide`} class="mb-8">
              {c}
            </swiper-slide>
          );
        })}
      </swiper-container>
    </div>
  );
};

export const Carousel = ({ data }) => {
  const swipeRef = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    swipeRef.current.addEventListener("afterinit", () => {
      setShow(true);
    });

    Object.assign(swipeRef.current, p);

    swipeRef.current.initialize();
  });

  useEffect(() => {
    if (swipeRef?.current?.initialized) {
      setShow(true);
    }
  }, [swipeRef?.current?.initialized]);

  const k = [...Array(5).keys()];

  return (
    <div className="max-w-full">
      <swiper-container
        init={false}
        ref={swipeRef}
        class={`${show ? "grid" : "hidden"}`}
      >
        {data?.map((c, key) => {
          return (
            <swiper-slide key={key} class="mb-8">
              <Thumbnail
                carouselItem={true}
                id={c?.id}
                thumbnail={c?.social?.thumbnail?.maxres?.url}
                title={c?.title}
                timestamp={c?.timestamp}
                duration={c?.duration}
                views={c?.social?.views}
              />
            </swiper-slide>
          );
        })}
      </swiper-container>
      {!show && (
        <div className="flex flex-col md:grid md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {k.map((_, i) => (
            <div key={i} className={i === 0 ? "" : "hidden md:inline-block"}>
              <Loading />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
